import type { ScheduleTaskType } from '@risksmart-app/domain/src/types/consts/schedule-task-type';
import { useQuery } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

/**
 * tRPC-only — there is no GraphQL equivalent, so this is a thin `useQuery`
 * wrapper rather than a `createQueryHook` bridge.
 *
 * Held back until a type is selected: the procedure requires at least one, so
 * firing on an empty list would only produce a guaranteed rejection.
 */
export const useGetSchedulableTargets = (taskTypes: ScheduleTaskType[]) => {
  const trpc = useTRPC();

  return useQuery({
    ...trpc.frontend.scheduler.getSchedulableTargets.queryOptions({
      TaskTypes: taskTypes,
    }),
    enabled: taskTypes.length > 0,
  });
};
